export const bTCMenu =[
  {
    //链上数据
    label: "menu.onchain",
    icon: "i itubiao2",
    nested: "peers", //没有多层嵌套
    id: "B01",
    children: [
      {
        //地址
        label: "menu.address",
        icon: "i izhexiantu-xianxing",
        id: "B01-1",
        children: [
          {
            //地址统计
            path: "/",
            label: "menu.onchain2",
            fullName: "menu.onchain2",
            icon: "i igl-folderOpen",
            componentReq: "newAddress2",
            radius: "btc",
            id: "B01-1-4",
            introduce: "introduce.address",
            navigation: "newAddress",
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
          {
            //盈利地址数
            path: "/",
            label: "menu.profitAddress",
            fullName: "menu.profitAddress",
            icon: "i igl-folderOpen",
            componentReq: "profitAddress",
            radius: "btc",
            id: "B01-1-1",
            introduce: "introduce.profitAddress",
            navigation: "profitAddress",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance", //匿名用户
          },
          {
            //亏损地址数
            path: "/",
            label: "menu.lossAddress",
            fullName: "menu.lossAddress",
            icon: "i igl-folderOpen",
            componentReq: "lossAddress",
            radius: "btc",
            id: "B01-1-2",
            introduce: "introduce.lossAddress",
            navigation: "lossAddress",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance", //匿名用户
          },
          {
            //地址盈亏比
            path: "/",
            label: "menu.profitRatio",
            fullName: "menu.profitRatio",
            icon: "i igl-folderOpen",
            componentReq: "profitRatio",
            radius: "btc",
            id: "B01-1-3",
            introduce: "introduce.profitRatio",
            navigation: "profitRatio",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance", //匿名用户
          },

          {
            //暂时注释 持有比特币超过100个的地址列表 改为 巨鲸地址列表 无权限
            path: "/",
            label: "menu.onchain15",
            fullName: "menu.onchain15",
            icon: "i igl-folderOpen",
            componentReq: "getTopList",
            radius: "btc",
            id: "B01-1-5",
            introduce: "introduce.getTopList",
            navigation: "topList", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //新增地址数
            path: "/",
            label: "menu.newAddress",
            fullName: "menu.newAddress",
            icon: "i igl-folderOpen",
            componentReq: "newAddress2",
            radius: "btc",
            id: "B01-1-6",
            introduce: "introduce.address",
            navigation: "newAddress2",
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
          {
            //新地址交易量
            path: "/",
            label: "menu.newAddressVolume",
            fullName: "menu.newAddressVolume",
            icon: "i igl-folderOpen",
            componentReq: "newAddress2",
            radius: "btc",
            id: "B01-1-7",
            introduce: "introduce.address",
            navigation: "newAddressVolume",
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
          {
            //总地址数
            path: "/",
            label: "menu.totalAddress",
            fullName: "menu.totalAddress",
            icon: "i igl-folderOpen",
            componentReq: "newAddress2",
            radius: "btc",
            id: "B01-1-8",
            introduce: "introduce.address",
            navigation: "totalAddress",
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
        ],
      },
      {
        //矿工
        label: "menu.Miners",
        icon: "i izhexiantu-xianxing",
        id: "B02-1",
        children: [
          {
            //发行价值（USD) 改为日发行价值 中英文都是 puell multiple
            path: "/",
            label: "menu.technology38",
            fullName: "menu.technology38",
            icon: "i igl-folderOpen",
            componentReq: "mintusd",
            radius: "btc",
            id: "B02-1-1",
            introduce: "introduce.mintusd",
            navigation: "mintusd", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户"
          },
          // {
          //   //矿工地址数 与矿工地址余额 合并 改为矿工余额
          //   path: "/",
          //   label: "menu.onchain20",
          //   fullName: "menu.onchain21",
          //   icon: "i igl-folderOpen",
          //   componentReq: "minerAddress",
          //   radius: "btc",
          //   id: "B02-1-2",
          //   introduce: "introduce.minerAddress",
          //   navigation: "minerAddress", //导航组件名称
          //   assets: "BTC",
          //   interval: "menu.interval3", //1天
          //   type: "L1",
          //   authority: "guest", //匿名用户
          // },
          {
            //矿工地址数
            path: "/",
            label: "menu.minerAddress",
            fullName: "menu.minerAddress",
            icon: "i igl-folderOpen",
            componentReq: "minerAddress",
            radius: "btc",
            id: "B02-1-3",
            introduce: "introduce.minerAddress",
            navigation: "minerAddress2", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3", //1天
            type: "L1",
            authority: "guest", //匿名用户
          },
          {
            //矿工地址余额
            path: "/",
            label: "menu.minerBalance",
            fullName: "menu.minerBalance",
            icon: "i igl-folderOpen",
            componentReq: "minerAddress",
            radius: "btc",
            id: "B02-1-4",
            introduce: "introduce.minerAddress",
            navigation: "minerBalance2", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3", //1天
            type: "L1",
            authority: "guest", //匿名用户
          },
        ],
      },
      {
        //网络
        label: "menu.Network",
        icon: "i izhexiantu-xianxing",
        id: "B03-1",
        children: [
          // {
          //   //日交易统计 更改名字 交易统计 拆分为 交易量、交易费、交易量(找零消除)
          //   path: "/",
          //   label: "menu.onchain19",
          //   fullName: "menu.onchain19",
          //   icon: "i igl-folderOpen",
          //   componentReq: "BTCVolume",
          //   radius: "btc",
          //   id: "B03-1-1",
          //   introduce: "introduce.BTCVolume",
          //   navigation: "volume", //导航组件名称
          //   assets: "BTC、ETH",
          //   interval: "menu.interval3",
          //   type: "L1",
          //   authority: "guest", //匿名用户
          // },
          {
            //交易汇率乘数
            path: "/",
            label: "menu.frm",
            fullName: "menu.frm",
            icon: "i igl-folderOpen",
            componentReq: "frm",
            radius: "btc",
            id: "B03-1-2",
            introduce: "introduce.frm",
            navigation: "frm",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered",
          },
          {
            //流通供应量
            path: "/",
            label: "menu.technology21",
            fullName: "menu.technology21",
            icon: "i igl-folderOpen",
            componentReq: "csupply",
            radius: "btc",
            id: "B03-1-3",
            introduce: "introduce.csupply",
            navigation: "csupply", //导航组件名称
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
          {
            path: "/", //大额交易
            label: "menu.onchain1",
            fullName: "menu.onchain1",
            icon: "i igl-folderOpen",
            componentReq: "ethbigtxcount",
            radius: "btc",
            id: "B03-1-4",
            introduce: "introduce.btcbigtxcount",
            navigation: "bigDeals",
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
          // {
          //   //待交易池详情 拆分为交易内存池数量、交易内存池费用
          //   path: "/",
          //   label: "menu.mempool",
          //   fullName: "menu.mempool", //全名
          //   icon: "i igl-folderOpen",
          //   componentReq: "mempool",
          //   radius: "btc",
          //   id: "B03-1-5",
          //   introduce: "introduce.mempool",
          //   navigation: "mempool", //导航组件名称
          //   assets: "BTC",
          //   interval: "menu.interval3",
          //   type: "L2",
          //   authority: "registered",
          // },
          {
            //交易量
            path: "/",
            label: "menu.TransactionVolume",
            fullName: "menu.TransactionVolume",
            icon: "i igl-folderOpen",
            componentReq: "BTCVolume",
            radius: "btc",
            id: "B03-1-6",
            introduce: "introduce.BTCVolume",
            navigation: "TransactionVolume", //导航组件名称
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
          {
            //交易费
            path: "/",
            label: "menu.TransactionFee",
            fullName: "menu.TransactionFee",
            icon: "i igl-folderOpen",
            componentReq: "BTCVolume",
            radius: "btc",
            id: "B03-1-7",
            introduce: "introduce.BTCVolume",
            navigation: "TransactionFee", //导航组件名称
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
          {
            //交易量(找零消除)
            path: "/",
            label: "menu.adjusted",
            fullName: "menu.adjusted",
            icon: "i igl-folderOpen",
            componentReq: "BTCVolume",
            radius: "btc",
            id: "B03-1-8",
            introduce: "introduce.BTCVolume",
            navigation: "adjusted", //导航组件名称
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
          {
            //交易内存池数量 memoryPoolFees
            path: "/",
            label: "menu.TransactionCount",
            fullName: "menu.TransactionCount", //全名
            icon: "i igl-folderOpen",
            componentReq: "mempool",
            radius: "btc",
            id: "B03-1-9",
            introduce: "introduce.mempool",
            navigation: "TransactionCount", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered",
          },
          {
            //交易内存池费用 
            path: "/",
            label: "menu.memoryPoolFees",
            fullName: "menu.memoryPoolFees", //全名
            icon: "i igl-folderOpen",
            componentReq: "mempool",
            radius: "btc",
            id: "B03-1-10",
            introduce: "introduce.mempool",
            navigation: "memoryPoolFees", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered",
          },
        ],
      },
      {
        //长/短期持有者
        label: "menu.LongShort",
        icon: "i izhexiantu-xianxing",
        id: "B04-1",
        children: [
          {
            //长期持有者每日交易量
            path: "/",
            label: "menu.lthVolume", //简写
            fullName: "menu.lthVolume2", //全名
            icon: "i igl-folderOpen",
            componentReq: "lthVolume",
            radius: "btc",
            id: "B04-1-1",
            introduce: "introduce.lthVolume",
            navigation: "lthVolume",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //长期持有者供应量
            path: "/",
            label: "menu.lthSupply",
            fullName: "menu.lthSupply2", //全名
            icon: "i igl-folderOpen",
            componentReq: "lthSupply",
            radius: "btc",
            id: "B04-1-2",
            introduce: "introduce.lthSupply",
            navigation: "lthSupply",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //长期持有者盈利总供应量 改为 长期持有者盈利供应量
            path: "/",
            label: "menu.lthProfitSupply",
            fullName: "menu.lthProfitSupply2", //全名
            icon: "i igl-folderOpen",
            componentReq: "lthProfitSupply",
            radius: "btc",
            id: "B04-1-3",
            introduce: "introduce.lthProfitSupply",
            navigation: "lthProfitSupply",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //长期持有者亏损总供应量 改为 长期持有者亏损供应量
            path: "/",
            label: "menu.lthLossSupply",
            fullName: "menu.lthLossSupply2", //全名
            icon: "i igl-folderOpen",
            componentReq: "lthLossSupply",
            radius: "btc",
            id: "B04-1-4",
            introduce: "introduce.lthLossSupply",
            navigation: "lthLossSupply",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //长期持有者盈亏比
            path: "/",
            label: "menu.lthProfitRatio",
            fullName: "menu.lthProfitRatio2", //全名
            icon: "i igl-folderOpen",
            componentReq: "lthProfitRatio",
            radius: "btc",
            id: "B04-1-5",
            introduce: "introduce.lthProfitRatio",
            navigation: "lthProfitRatio",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //短期持有者供应量
            path: "/",
            label: "menu.sthSupply",
            fullName: "menu.sthSupply2", //全名
            icon: "i igl-folderOpen",
            componentReq: "sthSupply",
            radius: "btc",
            id: "B04-1-13",
            introduce: "introduce.sthSupply",
            navigation: "sthSupply",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //短期持有者盈利总供应量 改为短期持有者盈利供应量
            path: "/",
            label: "menu.sthProfitSupply",
            fullName: "menu.sthProfitSupply2", //全名
            icon: "i igl-folderOpen",
            componentReq: "sthProfitSupply",
            radius: "btc",
            id: "B04-1-6",
            introduce: "introduce.sthProfitSupply",
            navigation: "sthProfitSupply",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //短期持有者亏损总供应量 改为短期持有者亏损供应量
            path: "/",
            label: "menu.sthLossSupply",
            fullName: "menu.sthLossSupply2", //全名
            icon: "i igl-folderOpen",
            componentReq: "sthLossSupply",
            radius: "btc",
            id: "B04-1-7",
            introduce: "introduce.sthLossSupply",
            navigation: "sthLossSupply",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //短期持有者盈亏比
            path: "/",
            label: "menu.sthProfitRatio",
            fullName: "menu.sthProfitRatio2", //全名
            icon: "i igl-folderOpen",
            componentReq: "sthProfitRatio",
            radius: "btc",
            id: "B04-1-8",
            introduce: "introduce.sthProfitRatio",
            navigation: "sthProfitRatio",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //长/短期持有者供应量盈亏比
            path: "/",
            label: "menu.relativeLthSth",
            fullName: "menu.relativeLthSth2", //全名
            icon: "i igl-folderOpen",
            componentReq: "relativeLthSth",
            radius: "btc",
            id: "B04-1-9",
            introduce: "introduce.relativeLthSth",
            navigation: "relativeLthSth",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //短期到长期实现价值比率
            path: "/",
            label: "menu.SLRVRatio",
            fullName: "menu.SLRVRatio2", //全名
            icon: "i igl-folderOpen",
            componentReq: "SLRVRatio",
            radius: "btc",
            id: "B04-1-10",
            introduce: "introduce.SLRVRatio",
            navigation: "SLRVRatio",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //长持者流通市值-已实现流通市值比 改为 长期持有者 MVRV Ratio
            path: "/",
            label: "menu.technology30",
            fullName: "menu.lthmvrv", //全名
            icon: "i igl-folderOpen",
            componentReq: "lthmvrv",
            radius: "btc",
            id: "B04-1-11",
            introduce: "introduce.lthmvrv",
            navigation: "lthmvrv", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance", //付费用户
          },
          {
            //短持者流通市值-已实现流通市值比 改为 短期持有者 MVRV Ratio
            path: "/",
            label: "menu.technology31",
            fullName: "menu.sthmvrv", //全名
            icon: "i igl-folderOpen",
            componentReq: "sthmvrv",
            radius: "btc",
            id: "B04-1-12",
            introduce: "introduce.sthmvrv",
            navigation: "sthmvrv", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance", //付费用户
          },
          {
            //长/短期持有者供应量盈亏分布
            path: "/",
            label: "menu.distributionLthSth",
            fullName: "menu.distributionLthSth", //全名
            icon: "i igl-folderOpen",
            componentReq: "distributionLthSth",
            radius: "btc",
            id: "B04-1-14",
            introduce: "introduce.distributionLthSth",
            navigation: "distributionLthSth", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance", //付费用户
          },
        ],
      },
      {
        //盈亏
        label: "menu.ProfitLoss",
        icon: "i izhexiantu-xianxing",
        id: "B05-1",
        children: [
          {
            //流通市值
            path: "/",
            label: "menu.technology28",
            fullName: "menu.marketcap", //全名
            icon: "i igl-folderOpen",
            componentReq: "marketcap",
            radius: "btc",
            id: "B05-1-1",
            introduce: "introduce.marketcap",
            navigation: "marketcap", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
          {
            //  已实现流通市值  改为和流通市值合并显示在一个页面 后期修改拆分
            path: "/",
            label: "menu.technology29",
            fullName: "menu.rcap", //全名
            icon: "i igl-folderOpen",
            componentReq: "rcap",
            radius: "btc",
            id: "B05-1-17",
            introduce: "introduce.rcap",
            navigation: "rcap", //导航组件名称
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest",
          },
          {
            //  已实现流通市值(找零消除)
            path: "/",
            label: "menu.earcap",
            fullName: "menu.earcap2", //全名
            icon: "i igl-folderOpen",
            componentReq: "earcap",
            radius: "btc",
            id: "B05-1-18",
            introduce: "introduce.earcap1",
            navigation: "earcap1", //导航组件名称
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered",
          },
          {
            //新的MVRV 改名 MVRV Ratio

            path: "/",
            label: "menu.technology1",
            fullName: "menu.mvrv", //全名
            icon: "i igl-folderOpen",
            componentReq: "market",
            radius: "mvrv",
            id: "B05-1-3",
            introduce: "introduce.MVRV",
            navigation: "mvrv",
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
          {
            //MVRVZ  MVRV Z-Score
            path: "/",
            label: "menu.technology2",
            fullName: "menu.technology2", //全名
            icon: "i igl-folderOpen",
            componentReq: "market",
            // req: "market",
            radius: "MVRVZ",
            coin: "BTC",
            id: "B05-1-4",
            introduce: "introduce.MVRVZ",
            navigation: "MVRVZ", //导航组件名称
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          },
          {
            //流通速度
            path: "/",
            label: "menu.velocity",
            fullName: "menu.velocity", //全名
            icon: "i igl-folderOpen",
            componentReq: "velocity",
            radius: "btc",
            id: "B05-1-2",
            introduce: "introduce.velocity",
            navigation: "velocity",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered",
          },

          {
            //已实现盈利量
            path: "/",
            label: "menu.technology25",
            fullName: "menu.technology25", //全名
            icon: "i igl-folderOpen",
            componentReq: "rprofit",
            radius: "btc",
            id: "B05-1-5",
            formula: "", //介绍公式
            introduce: "introduce.rprofit",
            navigation: "rprofit", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //已实现亏损量
            path: "/",
            label: "menu.technology26",
            fullName: "menu.technology26", //全名
            icon: "i igl-folderOpen",
            componentReq: "rloss",
            radius: "btc",
            id: "B05-1-6",
            introduce: "introduce.rloss",
            navigation: "rloss", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //已实现净收益损失比
            path: "/",
            label: "menu.technology27",
            fullName: "menu.technology27", //全名
            icon: "i igl-folderOpen",
            componentReq: "rplRate",
            radius: "btc",
            id: "B05-1-7",
            introduce: "introduce.rplRate",
            navigation: "rplRate", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //已实现价格
            path: "/",
            label: "menu.realizedPrice",
            fullName: "menu.realizedPrice", //全名
            icon: "i igl-folderOpen",
            componentReq: "realizedPrice",
            radius: "btc",
            id: "B05-1-8",
            introduce: "introduce.realizedPrice",
            navigation: "realizedPrice",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered",
          },
          {
            //已平衡价格
            path: "/",
            label: "menu.balancedPrice",
            fullName: "menu.balancedPrice", //全名
            icon: "i igl-folderOpen",
            componentReq: "balancedPrice",
            radius: "btc",
            id: "B05-1-9",
            introduce: "introduce.balancedPrice",
            navigation: "balancedPrice",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L3",
            authority: "advance",
          },
          {
            //累积价值-销毁天数比
            path: "/",
            label: "menu.cvdd",
            fullName: "menu.cvdd2", //全名
            icon: "i igl-folderOpen",
            componentReq: "cvdd",
            radius: "btc",
            id: "B05-1-10",
            introduce: "introduce.cvdd",
            navigation: "cvdd",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered",
          },
          {
            //未实现的净收益量
            path: "/",
            label: "menu.technology33",
            fullName: "menu.technology33", //全名
            icon: "i igl-folderOpen",
            componentReq: "uprofit",
            radius: "btc",
            id: "B05-1-12",
            introduce: "introduce.uprofit",
            navigation: "uprofit", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //未实现的净亏损量
            path: "/",
            label: "menu.technology34",
            fullName: "menu.technology34", //全名
            icon: "i igl-folderOpen",
            componentReq: "uloss",
            radius: "btc",
            id: "B05-1-13",
            introduce: "introduce.uloss",
            navigation: "uloss", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //未实现的净收益损失比
            path: "/",
            label: "menu.technology32",
            fullName: "menu.nupl", //全名
            icon: "i igl-folderOpen",
            componentReq: "nupl",
            radius: "btc",
            id: "B05-1-11",
            introduce: "introduce.nupl",
            navigation: "nupl", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },

          {
            //长持者未实现的净收益量 改为 长持者未实现的净收益损失比
            path: "/",
            label: "menu.technology35",
            fullName: "menu.lthnupl", //全名
            icon: "i igl-folderOpen",
            componentReq: "lthnupl",
            radius: "btc",
            id: "B05-1-14",
            introduce: "introduce.lthnupl",
            navigation: "lthnupl", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3", //改为1天
            type: "L3",
            authority: "advance", //付费用户
          },
          {
            //短持者未实现的净收益量  改为 短持者未实现的净收益损失比
            path: "/",
            label: "menu.technology36",
            fullName: "menu.sthnupl", //全名
            icon: "i igl-folderOpen",
            componentReq: "sthnupl",
            radius: "btc",
            id: "B05-1-15",
            introduce: "introduce.sthnupl",
            navigation: "sthnupl", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3", //改为1天
            type: "L3",
            authority: "advance", //付费用户
          },
          {
            //市值/交易价值比 NVT Ratio  改为 市盈率
            path: "/",
            label: "menu.nvtRatio",
            fullName: "menu.nvtRatio2", //全名
            icon: "i igl-folderOpen",
            componentReq: "nvtRatio",
            radius: "btc",
            id: "B05-1-16",
            introduce: "introduce.nvtRatio",
            navigation: "nvtRatio",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered",
          },
          {
            //NVT信号
            path: "/",
            label: "menu.nvtSign",
            fullName: "menu.nvtSign", //全名
            icon: "i igl-folderOpen",
            componentReq: "nvtSign",
            radius: "btc",
            id: "B05-1-19",
            introduce: "introduce.nvtSign",
            navigation: "nvtSign",
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered",
          },
        ],
      },
      {
        //币龄
        label: "menu.Lifetime",
        icon: "i izhexiantu-xianxing",
        id: "B06-1",
        children: [
          {
            //已花费输出平均寿命
            path: "/",
            label: "menu.technology18",
            fullName: "menu.asol", //全名
            icon: "i igl-folderOpen",
            componentReq: "asol",
            radius: "btc",
            id: "B06-1-1",
            introduce: "introduce.asol",
            navigation: "asol", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //币天销毁量
            path: "/",
            label: "menu.technology37",
            fullName: "menu.CDD", //全名
            icon: "i igl-folderOpen",
            componentReq: "CDD",
            radius: "btc",
            id: "B06-1-2",
            introduce: "introduce.CDD",
            navigation: "CDD", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //币天销毁量年龄分布
            path: "/",
            label: "menu.technology20",
            fullName: "menu.soag", //全名
            icon: "i igl-folderOpen",
            componentReq: "soag",
            radius: "btc",
            id: "B06-1-3",
            introduce: "introduce.soag",
            navigation: "soag", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //已花费输出休眠平均天数
            path: "/",
            label: "menu.technology19",
            fullName: "menu.technology19", //全名
            icon: "i igl-folderOpen",
            componentReq: "dormancy",
            radius: "btc",
            id: "B06-1-4",
            introduce: "introduce.dormancy",
            navigation: "dormancy", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //活跃度
            path: "/",
            label: "menu.technology24",
            fullName: "menu.technology24", //全名
            icon: "i igl-folderOpen",
            componentReq: "liveliness",
            radius: "btc",
            id: "B06-1-5",
            introduce: "introduce.Liveliness",
            navigation: "liveliness", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户"
          },
          {
            //币天销毁量 拆分 币天销毁量(供应调整)
            path: "/",
            label: "menu.saCDD",
            fullName: "menu.saCDD", //全名
            icon: "i igl-folderOpen",
            componentReq: "saCDD",
            radius: "btc",
            id: "B06-1-6",
            introduce: "introduce.CDD",
            navigation: "saCDD", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //已花费输出休眠平均天数 拆分 已花费输出休眠平均天数(供应量调整)
            path: "/",
            label: "menu.sadormancy",
            fullName: "menu.sadormancy", //全名
            icon: "i igl-folderOpen",
            componentReq: "sadormancy",
            radius: "btc",
            id: "B06-1-7",
            introduce: "introduce.dormancy",
            navigation: "sadormancy", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //价值销毁天数（VDD）倍数 价值损毁天数倍数
            path: "/",
            label: "menu.vdd",
            fullName: "menu.vdd", //全名
            icon: "i igl-folderOpen",
            componentReq: "vdd",
            radius: "btc",
            id: "B06-1-8",
            introduce: "introduce.vdd",
            navigation: "VDD", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
        ],
      },
      {
        //比率
        label: "menu.Ratio",
        icon: "i izhexiantu-xianxing",
        id: "B07-1",
        children: [
          {
            //已实现盈利交易占比 改成 每日已实现盈利交易占比（redmine）
            path: "/",
            label: "menu.technology16",
            fullName: "menu.technology16", //全名
            icon: "i igl-folderOpen",
            componentReq: "profitrate",
            radius: "btc",
            id: "B07-1-1",
            introduce: "introduce.profitrate",
            navigation: "profitrate", //导航组件名称
            assets: "BTC",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
          {
            //已花费输出盈利比
            path: "/",
            label: "menu.technology17",
            fullName: "menu.SOPR", //全名
            icon: "i igl-folderOpen",
            componentReq: "sopr",
            radius: "btc",
            id: "B07-1-2",
            introduce: "introduce.sopr",
            navigation: "sopr", //导航组件名称
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L2",
            authority: "registered", //注册用户
          },
        ],
      },
      {
        //持有者分布
        label: "menu.Holder",
        icon: "i izhexiantu-xianxing",
        id: "B08-1",
        children: [
          // {
          //   //按余额划分
          //   label: "menu.balanceGroup",
          //   icon: "i izhexiantu-xianxing",
          //   id: "B08-1-1",
          //   children: [
          //     {
          //       //持有者地址数分布( 按余额分段) 改为 地址数分布
          //       path: "/",
          //       label: "menu.onchain5",
          //       fullName: "menu.onchain5", //全名
          //       icon: "i igl-folderOpen",
          //       componentReq: "utxos",
          //       radius: "btc",
          //       id: "B08-1-1-1",
          //       introduce: "introduce.balanceDistribution",
          //       navigation: "utxos",
          //       assets: "BTC",
          //       interval: "menu.interval3",
          //       type: "L3",
          //       authority: "advance", //付费用户
          //     },
          //     {
          //       //持有者币数量分布(按余额分段) 改为 币数量分布
          //       path: "/",
          //       label: "menu.onchain6",
          //       fullName: "menu.onchain6", //全名
          //       icon: "i igl-folderOpen",
          //       componentReq: "utxos2nd",
          //       radius: "btc",
          //       id: "B08-1-1-2",
          //       introduce: "introduce.balanceDistribution",
          //       navigation: "utxos2nd",
          //       assets: "BTC",
          //       interval: "menu.interval3",
          //       type: "L3",
          //       authority: "advance", //付费用户
          //     },
          //   ],
          // },
          {
            //按余额划分 改为 按余额划分地址数分布
            label: "menu.balanceGroup2",
            icon: "i izhexiantu-xianxing",
            id: "B08-1-8",
            children: [
              {
                //按余额划分 地址数分布 余额 <=0.01
                path: "/",
                label: "menu.addressBalance",
                fullName: "menu.addressBalance", //全名
                icon: "i igl-folderOpen",
                componentReq: "addressBalance",
                radius: "btc",
                id: "B08-1-8-1",
                introduce: "introduce.balanceDistribution",
                navigation: "addressBalance",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 地址数分布  余额 >=0.01 & <0.1
                path: "/",
                label: "menu.addressBalance1",
                fullName: "menu.addressBalance1", //全名
                icon: "i igl-folderOpen",
                componentReq: "addressBalance1",
                radius: "btc",
                id: "B08-1-8-2",
                introduce: "introduce.balanceDistribution",
                navigation: "addressBalance1",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 地址数分布  余额 >=0.1 & <1 
                path: "/",
                label: "menu.addressBalance2",
                fullName: "menu.addressBalance2", //全名
                icon: "i igl-folderOpen",
                componentReq: "addressBalance2",
                radius: "btc",
                id: "B08-1-8-3",
                introduce: "introduce.balanceDistribution",
                navigation: "addressBalance2",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 地址数分布  余额 >=1 & <10
                path: "/",
                label: "menu.addressBalance3",
                fullName: "menu.addressBalance3", //全名
                icon: "i igl-folderOpen",
                componentReq: "addressBalance3",
                radius: "btc",
                id: "B08-1-8-4",
                introduce: "introduce.balanceDistribution",
                navigation: "addressBalance3",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 地址数分布  余额 >=10 & <100
                path: "/",
                label: "menu.addressBalance4",
                fullName: "menu.addressBalance4", //全名
                icon: "i igl-folderOpen",
                componentReq: "addressBalance4",
                radius: "btc",
                id: "B08-1-8-5",
                introduce: "introduce.balanceDistribution",
                navigation: "addressBalance4",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 地址数分布  余额 >=100 & <1000
                path: "/",
                label: "menu.addressBalance5",
                fullName: "menu.addressBalance5", //全名
                icon: "i igl-folderOpen",
                componentReq: "addressBalance5",
                radius: "btc",
                id: "B08-1-8-6",
                introduce: "introduce.balanceDistribution",
                navigation: "addressBalance5",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 地址数分布  余额 >=1000 & <10000
                path: "/",
                label: "menu.addressBalance6",
                fullName: "menu.addressBalance6", //全名
                icon: "i igl-folderOpen",
                componentReq: "addressBalance6",
                radius: "btc",
                id: "B08-1-8-7",
                introduce: "introduce.balanceDistribution",
                navigation: "addressBalance6",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 地址数分布  余额 >=10000
                path: "/",
                label: "menu.addressBalance7",
                fullName: "menu.addressBalance7", //全名
                icon: "i igl-folderOpen",
                componentReq: "addressBalance7",
                radius: "btc",
                id: "B08-1-8-8",
                introduce: "introduce.balanceDistribution",
                navigation: "addressBalance7",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
             
             
             
             
            ],
          },
          {
            //按余额划分 改为 按余额划分币数量分布
            label: "menu.currencyGroup",
            icon: "i izhexiantu-xianxing",
            id: "B08-1-9",
            children: [
              {
                //按余额划分 币数量分布 余额 <=0.01
                path: "/",
                label: "menu.currencyGroup1",
                fullName: "menu.currencyGroup1", //全名
                icon: "i igl-folderOpen",
                componentReq: "currencyGroup1",
                radius: "btc",
                id: "B08-1-9-1",
                introduce: "introduce.balanceDistribution",
                navigation: "currencyGroup1",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 币数量分布 余额 >=0.01 & <0.1
                path: "/",
                label: "menu.currencyGroup2",
                fullName: "menu.currencyGroup2", //全名
                icon: "i igl-folderOpen",
                componentReq: "currencyGroup2",
                radius: "btc",
                id: "B08-1-9-2",
                introduce: "introduce.balanceDistribution",
                navigation: "currencyGroup2",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 币数量分布 余额 >=0.1 & <1
                path: "/",
                label: "menu.currencyGroup3",
                fullName: "menu.currencyGroup3", //全名
                icon: "i igl-folderOpen",
                componentReq: "currencyGroup3",
                radius: "btc",
                id: "B08-1-9-3",
                introduce: "introduce.balanceDistribution",
                navigation: "currencyGroup3",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 币数量分布 "余额 >=1 & <10  
                path: "/",
                label: "menu.currencyGroup4",
                fullName: "menu.currencyGroup4", //全名
                icon: "i igl-folderOpen",
                componentReq: "currencyGroup4",
                radius: "btc",
                id: "B08-1-9-4",
                introduce: "introduce.balanceDistribution",
                navigation: "currencyGroup4",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 币数量分布 余额 >=10 & <100
                path: "/",
                label: "menu.currencyGroup5",
                fullName: "menu.currencyGroup5", //全名
                icon: "i igl-folderOpen",
                componentReq: "currencyGroup5",
                radius: "btc",
                id: "B08-1-9-5",
                introduce: "introduce.balanceDistribution",
                navigation: "currencyGroup5",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 币数量分布 余额 >=100 & <1000
                path: "/",
                label: "menu.currencyGroup6",
                fullName: "menu.currencyGroup6", //全名
                icon: "i igl-folderOpen",
                componentReq: "currencyGroup6",
                radius: "btc",
                id: "B08-1-9-6",
                introduce: "introduce.balanceDistribution",
                navigation: "currencyGroup6",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 币数量分布 余额 >=1000 & <10000
                path: "/",
                label: "menu.currencyGroup7",
                fullName: "menu.currencyGroup7", //全名
                icon: "i igl-folderOpen",
                componentReq: "currencyGroup7",
                radius: "btc",
                id: "B08-1-9-7",
                introduce: "introduce.balanceDistribution",
                navigation: "currencyGroup7",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //按余额划分 币数量分布 余额 >=10000
                path: "/",
                label: "menu.currencyGroup8",
                fullName: "menu.currencyGroup8", //全名
                icon: "i igl-folderOpen",
                componentReq: "currencyGroup8",
                radius: "btc",
                id: "B08-1-9-8",
                introduce: "introduce.balanceDistribution",
                navigation: "currencyGroup8",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
           
           
           
             
             
             
             
            ],
          },
          {
            //按持有时间划分
            label: "menu.timeGroup",
            icon: "i izhexiantu-xianxing",
            id: "B08-1-2",
            children: [
              {
                //持有者地址数分布( 按持有时间分段)  改为 地址数分布
                path: "/",
                label: "menu.onchain7",
                fullName: "menu.onchain7", //全名
                icon: "i igl-folderOpen",
                componentReq: "holder",
                radius: "btc",
                id: "B08-1-2-1",
                introduce: "introduce.holder",
                navigation: "holder",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //持有者币数量分布( 按持有时间分段) 改为 币数量分布
                path: "/",
                label: "menu.onchain8",
                fullName: "menu.onchain8", //全名
                icon: "i igl-folderOpen",
                componentReq: "holderBalance",
                radius: "btc",
                id: "B08-1-2-2",
                introduce: "introduce.timeDivision",
                navigation: "holderBalance",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
            ],
          },
          {
            //按买入价格划分
            label: "menu.priceGroup",
            icon: "i izhexiantu-xianxing",
            id: "B08-1-3",
            children: [
              {
                //持有者地址数分布( 按买入价格分段) 改为 地址数分布
                path: "/",
                label: "menu.onchain9",
                fullName: "menu.onchain9", //全名
                icon: "i igl-folderOpen",
                componentReq: "getBuyData",
                radius: "btc",
                id: "B08-1-3-1",
                introduce: "introduce.buyingPrice",
                navigation: "buyData", //导航组件名称
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //持有者币数量分布( 按买入价格分段) 改为 币数量分布
                path: "/", //与Buy Data共用
                label: "menu.onchain10",
                fullName: "menu.onchain10", //全名
                icon: "i igl-folderOpen",
                componentReq: "getBuyAmountData",
                radius: "btc",
                id: "B08-1-3-2",
                introduce: "introduce.buyingPrice",
                navigation: "buyData", //导航组件名称
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
            ],
          },
          {
            //按买卖价差划分
            label: "menu.PriceDifference",
            icon: "i izhexiantu-xianxing",
            id: "B08-1-4",
            children: [
              {
                //持有者地址数分布(盈亏) 改为  地址数分布
                path: "/",
                label: "menu.onchain11",
                fullName: "menu.onchain11", //全名
                icon: "i igl-folderOpen",
                componentReq: "getDiffData",
                radius: "btc",
                id: "B08-1-4-1",
                introduce: "introduce.priceDivision",
                navigation: "diffData", //导航组件名称
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //持有者币数量分布(盈亏) 改为 币数量分布
                path: "/", //与Diff Data共用
                label: "menu.onchain12",
                fullName: "menu.onchain12", //全名
                icon: "i igl-folderOpen",
                componentReq: "getDiffAmountData",
                radius: "btc",
                id: "B08-1-4-2",
                introduce: "introduce.priceDivision1",
                navigation: "diffData", //导航组件名称
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
            ],
          },
          {
            //按按盈利划分
            label: "menu.profitGroup",
            icon: "i izhexiantu-xianxing",
            id: "B08-1-5",
            children: [
              {
                //持有者地址数分布(利润率)  改为 地址数分布
                path: "/",
                label: "menu.onchain13",
                fullName: "menu.onchain13", //全名
                icon: "i igl-folderOpen",
                componentReq: "getProfitData",
                radius: "btc",
                id: "B08-1-5-1",
                introduce: "introduce.profitDistribution",
                navigation: "profitData", //导航组件名称
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
              {
                //持有者币数量分布(利润率) 改为 币数量分布
                path: "/", //与Profit Data共用
                label: "menu.onchain14",
                fullName: "menu.onchain14", //全名
                icon: "i igl-folderOpen",
                componentReq: "getProfitAmountData",
                radius: "btc",
                id: "B08-1-5-2",
                introduce: "introduce.profitDistribution",
                navigation: "profitData", //导航组件名称
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
              },
            ],
          },
          {
            //地址详细分布
            label: "menu.addressGroup",
            icon: "i izhexiantu-xianxing",
            id: "B08-1-6",
            children: [
              {
                //余额>=0 and <0.01的地址 币龄分布表 改为 余额<0.01
                // path: "/",
                label: "menu.Currency2",
                componentReq: "getDayBalanceData",
                fullName: "menu.balanceData1", //全名
                radius: "btc",
                id: "B08-1-6-1",
                value: 0,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 0,
              },
              {
                // path: "/",   改为 余额>=0.01 & < 0.1
                label: "menu.Currency3",
                componentReq: "getDayBalanceData",
                fullName: "menu.balanceData2", //全名
                radius: "btc",
                id: "B08-1-6-2",
                value: 0.01,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 0.01,
              },
              {
                // path: "/",  改为 余额>=0.1 & < 1
                label: "menu.Currency4",
                fullName: "menu.balanceData3", //全名
                componentReq: "getDayBalanceData",
                radius: "btc",
                id: "B08-1-6-3",
                value: 0.1,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 0.1,
              },
              {
                // path: "/",  余额>=1 & < 10
                label: "menu.Currency5",
                fullName: "menu.balanceData4", //全名
                componentReq: "getDayBalanceData",
                radius: "btc",
                id: "B08-1-6-4",
                value: 1,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 1,
              },
              {
                // path: "/", 余额>=10 & < 100
                label: "menu.Currency6",
                fullName: "menu.balanceData5", //全名
                componentReq: "getDayBalanceData",
                radius: "btc",
                id: "B08-1-6-5",
                value: 10,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 10,
              },
              {
                // path: "/",余额>=100 & < 1000
                label: "menu.Currency7",
                fullName: "menu.balanceData6", //全名
                componentReq: "getDayBalanceData",
                radius: "btc",
                id: "B08-1-6-6",
                value: 100,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 100,
              },
              {
                // path: "/", 余额>=1000 & < 10000
                label: "menu.Currency8",
                fullName: "menu.balanceData7", //全名
                componentReq: "getDayBalanceData",
                radius: "btc",
                id: "B08-1-6-7",
                value: 1000,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 1000,
              },
              {
                // path: "/", 余额>=10000
                label: "menu.Currency9",
                fullName: "menu.balanceData8", //全名
                componentReq: "getDayBalanceData",
                radius: "btc",
                id: "B08-1-6-8",
                value: 10000,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 10000,
              },
            ],
          },
          {
            //币数量详细分布
            label: "menu.CoinQuantity",
            icon: "i izhexiantu-xianxing",
            id: "B08-1-7",
            children: [
              {
                //余额>=0 and <0.01的币数量 币龄分布表 改为 余额<0.01
                // path: "/",
                label: "menu.Currency11",
                fullName: "menu.balanceData9", //全名
                componentReq: "getDayBalanceAmountData",
                radius: "btc",
                id: "B08-1-7-1",
                value: 0,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 0,
              },
              {
                // path: "/", 余额>=0.01 & < 0.1
                label: "menu.Currency12",
                fullName: "menu.balanceData10", //全名
                componentReq: "getDayBalanceAmountData",
                radius: "btc",
                id: "B08-1-7-2",
                value: 0.01,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 0.01,
              },
              {
                // path: "/",余额>=0.1 & < 1
                label: "menu.Currency13",
                fullName: "menu.balanceData11", //全名
                componentReq: "getDayBalanceAmountData",
                radius: "btc",
                id: "B08-1-7-3",
                value: 0.1,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 0.1,
              },
              {
                // path: "/",  余额>=1 & < 10
                label: "menu.Currency14",
                fullName: "menu.balanceData12", //全名
                componentReq: "getDayBalanceAmountData",
                radius: "btc",
                id: "B08-1-7-4",
                value: 1,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 1,
              },
              {
                // path: "/", 余额>=10 & < 100
                label: "menu.Currency15",
                fullName: "menu.balanceData13", //全名
                componentReq: "getDayBalanceAmountData",
                radius: "btc",
                id: "B08-1-7-5",
                value: 10,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 10,
              },
              {
                // path: "/",  余额>=100 & < 1000
                label: "menu.Currency16",
                fullName: "menu.balanceData14", //全名
                componentReq: "getDayBalanceAmountData",
                radius: "btc",
                id: "B08-1-7-6",
                value: 100,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 100,
              },
              {
                // path: "/", 余额>=1000 & < 10000
                label: "menu.Currency17",
                fullName: "menu.balanceData15", //全名
                componentReq: "getDayBalanceAmountData",
                radius: "btc",
                id: "B08-1-7-7",
                value: 1000,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 1000,
              },
              {
                // path: "/",  余额>=10000
                label: "menu.Currency18",
                fullName: "menu.balanceData16", //全名
                componentReq: "getDayBalanceAmountData",
                radius: "btc",
                id: "B08-1-7-8",
                value: 10000,
                introduce: "introduce.detailedDistribution",
                navigation: "balanceData",
                assets: "BTC",
                interval: "menu.interval3",
                type: "L3",
                authority: "advance", //付费用户
                parameter: 10000,
              },
            ],
          },
        ],
      },
    ],
  },
  //#region
  // {
  //   //链上数据
  //   label: "menu.onchain",
  //   icon: "i itubiao2",
  //   nested: "peers", //没有多层嵌套
  //   id: "01",
  //   children: [

  //     // {
  //     //   //日交易统计
  //     //   path: "/",
  //     //   label: "menu.onchain19",
  //     //   icon: "i igl-folderOpen",
  //     //   componentReq: "BTCVolume",
  //     //   radius: "btc",
  //     //   id: "01-4",
  //     //   introduce: "introduce.BTCVolume",
  //     //   navigation: "volume", //导航组件名称
  //     //   assets: "BTC、ETH",
  //     //   interval: "menu.interval3",
  //     // },

  //     // { //暂时不渲染  累计币天销毁量(流通供应量）
  //     //   path: "/",
  //     //   label: "menu.technology22",
  //     //   icon: "i igl-folderOpen",
  //     //   componentReq: "sumcsupply",
  //     //   radius: "btc",
  //     //   id: "01-11",
  //     //   introduce:
  //     //     "Liveliness to vary between a value of 1 for a protocol where every coin is spent at once, and 0 for a protocol where no transaction has taken place. Analysis of metric values between the theoretical extremes of 1 and 0 can generally be considered within the following framework:Liveliness will decrease when a high proportion of coin supply is dormant (i.e. HODLing behaviour) and the global coin day accumulation outpaces coin days destroyed in on-chain activity. Liveliness will trend sideways where coin days destroyed are equal to the coin days accumulated by the circulating supply.Liveliness will increase when long term holders begin spending old coins that have accumulated large volumes of coin days that exceed the rate of global coin day accumulation.",
  //     //   navigation: "sumcsupply", //导航组件名称
  //     //   assets: "BTC",
  //     //   interval: "menu.interval3",
  //     // },
  //     // {//暂时不渲染 累计币天销毁量
  //     //   path: "/",
  //     //   label: "menu.technology23",
  //     //   icon: "i igl-folderOpen",
  //     //   componentReq: "sumcdd",
  //     //   radius: "btc",
  //     //   id: "01-12",
  //     //   introduce:
  //     //     "Liveliness to vary between a value of 1 for a protocol where every coin is spent at once, and 0 for a protocol where no transaction has taken place. Analysis of metric values between the theoretical extremes of 1 and 0 can generally be considered within the following framework:Liveliness will decrease when a high proportion of coin supply is dormant (i.e. HODLing behaviour) and the global coin day accumulation outpaces coin days destroyed in on-chain activity. Liveliness will trend sideways where coin days destroyed are equal to the coin days accumulated by the circulating supply.Liveliness will increase when long term holders begin spending old coins that have accumulated large volumes of coin days that exceed the rate of global coin day accumulation.",
  //     //   navigation: "sumcdd", //导航组件名称
  //     //   assets: "BTC",
  //     //   interval: "menu.interval3",
  //     // },

  //     // {
  //     //   //矿工地址余额
  //     //   path: "/",
  //     //   label: "menu.onchain21",
  //     //   icon: "i igl-folderOpen",
  //     //   componentReq: "minerBalance",
  //     //   radius: "btc",
  //     //   id: "01-24",
  //     //   introduce: "introduce.minerBalance",
  //     //   navigation: "minerBalance", //导航组件名称
  //     //   assets: "BTC",
  //     //   interval: "menu.interval3",
  //     // },
  //   ],
  // },
  //#endregion
  {
    //市场技术指标 改为 市场指标
    label: "menu.market",
    icon: "i i-zhuzhuangtu",
    nested: "peers", //判断是否多层嵌套
    id: "2",
    children: [
      {
        //江卓尔60日累计涨幅
        path: "/",
        label: "menu.technology6",
        fullName: "menu.jzr60", //全名
        icon: "i igl-folderOpen",
        componentReq: "jzr60",
        radius: "btc",
        id: "2-1",
        // conditions: "arh", //不同请求方式筛选条件
        introduce: "introduce.jzr60",
        navigation: "jzr60",
        assets: "BTC、ETH",
        interval: "menu.interval3",
        type: "L1",
        authority: "guest", //匿名用户
      },
      {
        //arh999囤币及逃顶指标
        path: "/",
        label: "menu.technology7",
        fullName: "menu.arh999", //全名
        icon: "i igl-folderOpen",
        componentReq: "arh99",
        radius: "btc",
        id: "2-2",
        navigation: "arh999",
        // conditions: "arh", //不同请求方式筛选条件
        introduce: "introduce.arh999",
        assets: "BTC、ETH",
        interval: "menu.interval3",
        type: "L1",
        authority: "guest", //匿名用户
      },
      // {
      //   //天针
      //   path: "/",
      //   label: "menu.technology8",
      //   icon: "i igl-folderOpen",
      //   componentReq: "天针",
      //   radius: "btc",
      //   id: "2-3",
      //   introduce: "introduce.DaysNeedle",
      //   navigation: "DaysNeedle", //导航组件名称
      //   assets: "无",
      //   interval: "menu.interval3",
      // },
      {
        //2年移动平均价格乘数
        path: "/",
        label: "menu.technology11",
        fullName: "menu.ma730", //全名
        icon: "i igl-folderOpen",
        componentReq: "ma730",
        radius: "btc",
        id: "2-4",
        introduce: "introduce.ma730",
        navigation: "ma730", //导航组件名称
        assets: "BTC、ETH",
        interval: "menu.interval3",
        type: "L1",
        authority: "guest", //匿名用户
      },
      {
        //币价当前市值排名
        path: "/",
        label: "menu.onchain17",
        fullName: "menu.coinmarketall", //全名
        icon: "i igl-folderOpen",
        componentReq: "币价当前市值排名",
        radius: "btc",
        id: "2-5",
        introduce: "introduce.coinmarketall",
        navigation: "coinmarketall", //导航组件名称
        assets: "BTC",
        interval: "menu.interval3",
        type: "L2",
        authority: "registered", //注册用户
      },

      // {
      //   //日K线 删除不显示
      //   path: "/",
      //   label: "menu.technology5",
      //   icon: "i igl-folderOpen",
      //   componentReq: "OHLCPrice",
      //   radius: "BTC",
      //   id: "2-7",
      //   introduce: "introduce.OHLCPrice",
      //   navigation: "ETH",
      //   assets: "BTC, ETH",
      //   interval: "menu.interval3",
      //   type: "L2",
      //   authority: "registered", //注册用户
      // },
      //  {
      //   //登录遮罩
      //   path: "/",
      //   label: "遮罩",
      //   icon: "i igl-folderOpen",
      //   componentReq: "mask",
      //   radius: "BTC",
      //   id: "2-8",
      //   introduce: "",
      //   navigation: "loginMask",
      //   assets: "BTC, ETH",
      //   interval: "menu.interval3",
      // },
      {
        //PI周期顶指标
        path: "/",
        label: "menu.PiCycleTopIndicator",
        fullName: "menu.PiCycleTopIndicator", //全名
        icon: "i igl-folderOpen",
        componentReq: "piCycleTop",
        radius: "btc",
        id: "2-9",
        introduce: "introduce.PiCycleTopIndicator",
        navigation: "piCycleTop", //导航组件名称
        assets: "BTC",
        interval: "menu.interval3",
        type: "L1",
        authority: "guest", //匿名用户
      },
      {
        //稳定币供应比
        path: "/",
        label: "menu.ssr",
        fullName: "menu.ssr", //全名
        icon: "i igl-folderOpen",
        componentReq: "ssr",
        radius: "btc",
        id: "2-10",
        introduce: "introduce.ssr",
        navigation: "ssr", //导航组件名称
        assets: "BTC",
        interval: "menu.interval3",
        type: "L2",
        authority: "registered",
      },
      {
        //稳定币供应比振荡器
        path: "/",
        label: "menu.ssro",
        fullName: "menu.ssro", //全名
        icon: "i igl-folderOpen",
        componentReq: "ssro",
        radius: "btc",
        id: "2-11",
        introduce: "introduce.ssro",
        navigation: "ssro", //导航组件名称
        assets: "BTC",
        interval: "menu.interval3",
        type: "L2",
        authority: "registered",
      },
      {
        //库存/新发行比
        path: "/",
        label: "menu.stfRatio",
        fullName: "menu.stfRatio", //全名
        icon: "i igl-folderOpen",
        componentReq: "stfRatio",
        radius: "btc",
        id: "2-12",
        introduce: "introduce.stfRatio",
        navigation: "stfRatio", //导航组件名称
        assets: "BTC",
        interval: "menu.interval3",
        type: "L1",
        authority: "guest",
      },
      {
        //库存/新发行偏差
        path: "/",
        label: "menu.stfDeflection",
        fullName: "menu.stfDeflection", //全名
        icon: "i igl-folderOpen",
        componentReq: "stfDeflection",
        radius: "btc",
        id: "2-13",
        introduce: "introduce.stfDeflection",
        navigation: "stfDeflection", //导航组件名称
        assets: "BTC",
        interval: "menu.interval3",
        type: "L2",
        authority: "registered",
      },
      {
        //黄金比例乘数
        path: "/",
        label: "menu.goldenRatioMult",
        fullName: "menu.goldenRatioMult", //全名
        icon: "i igl-folderOpen",
        componentReq: "goldenRatioMult",
        radius: "btc",
        id: "2-14",
        introduce: "introduce.goldenRatioMult",
        navigation: "goldenRatioMult", //导航组件名称
        assets: "BTC、ETH",
        interval: "menu.interval3",
        type: "L2",
        authority: "registered",
      },
    ],
  },
 
  {
    //交易所数据

    label: "menu.exchange",
    icon: "i itubiao2",
    nested: "peers", //判断是否多层嵌套
    id: "4",
    children: [
      //#region
      // {
      //   //合约K线
      //   path: "/Bian",
      //   label: "menu.exchange1",
      //   icon: "i igl-folderOpen",
      //   // componentReq: "list",
      //   radius: "bian",
      //   id: "4-1",
      //   navigation: "bianController",
      //   introduce: "introduce.bian",
      //   assets:
      //     "'BTCUSDT,ETHUSDT,BCHUSDT,XRPUSDT,EOSUSDT,LTCUSDT,TRXUSDT,ETCUSDT,LINKUSDT,XLMUSDT,ADAUSDT,XMRUSDT,DASHUSDT,ZECUSDT,XTZUSDT,BNBUSDT,ATOMUSDT,ONTUSDT,IOTAUSDT,BATUSDT,VETUSDT,NEOUSDT,QTUMUSDT,IOSTUSDT,THETAUSDT,ALGOUSDT,ZILUSDT,KNCUSDT,ZRXUSDT,COMPUSDT,OMGUSDT,DOGEUSDT,SXPUSDT,KAVAUSDT,BANDUSDT,RLCUSDT,WAVESUSDT,MKRUSDT,SNXUSDT,DOTUSDT,DEFIUSDT,YFIUSDT,BALUSDT,CRVUSDT,TRBUSDT,RUNEUSDT,SUSHIUSDT,SRMUSDT,EGLDUSDT,SOLUSDT,ICXUSDT,STORJUSDT,BLZUSDT,UNIUSDT,AVAXUSDT,FTMUSDT,HNTUSDT,ENJUSDT,FLMUSDT,TOMOUSDT,RENUSDT,KSMUSDT,NEARUSDT,AAVEUSDT,FILUSDT,RSRUSDT,LRCUSDT,MATICUSDT,OCEANUSDT,CVCUSDT,BELUSDT,CTKUSDT,AXSUSDT,ALPHAUSDT,ZENUSDT,SKLUSDT,GRTUSDT,1INCHUSDT,CHZUSDT,SANDUSDT,ANKRUSDT,BTSUSDT,LITUSDT,UNFIUSDT,REEFUSDT,RVNUSDT,SFPUSDT,XEMUSDT,BTCSTUSDT,COTIUSDT,CHRUSDT,MANAUSDT,ALICEUSDT,HBARUSDT'",
      //   interval: "menu.interval3",
      // },
      // {
      //   //交易量
      //   path: "/", //与Get Top List共用
      //   label: "menu.exchange2",
      //   icon: "i igl-folderOpen",
      //   componentReq: "priceValue",
      //   radius: "btc",
      //   id: "4-2",
      //   introduce: "introduce.priceValue",
      //   navigation: "priceValue", //导航组件名称
      //   assets: "BTC",
      //   interval: "menu.interval3",
      // },
      //#endregion
      {
        //资金费率
        path: "/",
        label: "menu.technology13",
        fullName: "menu.technology13", //全名
        icon: "i igl-folderOpen",
        componentReq: "fundingRate",
        radius: "btc",
        id: "4-3",
        introduce: "introduce.fundingRate",
        navigation: "fundingRate", //导航组件名称
        assets: "BTCUSDT、ETHUSDT",
        interval: "menu.interval3",
        type: "L1",
        authority: "guest", //注册用户
      },
      {
        //未平仓合约数
        path: "/",
        label: "menu.technology14",
        fullName: "menu.technology14", //全名
        icon: "i igl-folderOpen",
        componentReq: "openInterest",
        radius: "btc",
        id: "4-4",
        introduce: "introduce.openInterest",
        navigation: "openInterest", //导航组件名称
        assets: "BTCUSDT、ETHUSDT",
        interval: "menu.interval3",
        type: "L2",
        authority: "registered", //注册用户
      },

      {
        //合约主动买入量
        path: "/",
        label: "menu.technology15",
        fullName: "menu.technology15", //全名
        icon: "i igl-folderOpen",
        componentReq: "takerlongshortRatio",
        radius: "btc",
        id: "4-5",
        introduce: "introduce.takerlongshortRatio",
        navigation: "takerlongshortRatio", //导航组件名称
        assets: "BTCUSDT、ETHUSDT",
        interval: "menu.interval3",
        type: "L2",
        authority: "registered", //注册用户
      },
      {
        //时区购买力
        path: "/",
        label: "menu.tzbp",
        fullName: "menu.tzbp", //全名
        icon: "i igl-folderOpen",
        componentReq: "tzbp",
        radius: "btc",
        id: "4-6",
        introduce: "introduce.tzbp",
        navigation: "tzbp", //导航组件名称
        assets: "BTC、ETH",
        interval: "menu.interval3",
        type: "L3",
        authority: "advance",
      },
      {
        //买入大单挂单
        path: "/",
        label: "menu.bobp",
        fullName: "menu.bobp", //全名
        icon: "i igl-folderOpen",
        componentReq: "bobp",
        radius: "btc",
        id: "4-7",
        introduce: "introduce.bobp",
        navigation: "bobp", //导航组件名称
        assets: "BTC、ETH",
        interval: "menu.interval3",
        type: "L3",
        authority: "advance",
      },
      {
        //卖出大单挂单
        path: "/",
        label: "menu.bosp",
        fullName: "menu.bosp", //全名
        icon: "i igl-folderOpen",
        componentReq: "bosp",
        radius: "btc",
        id: "4-8",
        introduce: "introduce.bobp", //买入卖出都一样
        navigation: "bosp", //导航组件名称
        assets: "BTC、ETH",
        interval: "menu.interval3",
        type: "L3",
        authority: "advance",
      },
      // {
      //   //成交量分布图
      //   path: "/",
      //   label: "menu.volumeProfile",
      //   fullName: "menu.volumeProfile", //全名
      //   icon: "i igl-folderOpen",
      //   componentReq: "volumeProfile",
      //   radius: "btc",
      //   id: "4-9",
      //   introduce: "introduce.volumeProfile",
      //   navigation: "volumeProfile", //导航组件名称
      //   assets: "BTC",
      //   interval: "menu.interval3",
      //   type: "L3",
      //   authority: "advance",
      // },
      {
        //交易所余额
        path: "/",
        label: "menu.exchange10",
        fullName: "menu.exchange10", //全名
        icon: "i igl-folderOpen",
        componentReq: "exchange",
        radius: "btc",
        id: "4-10",
        introduce: "introduce.exchange1",
        navigation: "exchange", //导航组件名称
        assets: "BTC、ETH",
        interval: "menu.interval3",
        type: "L2",
        authority: "registered",
      },
      {
        //合约主动买入量 拆分出来 合约主动买入量(买卖比率)
        path: "/",
        label: "menu.sellRatio",
        fullName: "menu.sellRatio", //全名
        icon: "i igl-folderOpen",
        componentReq: "sellRatio",
        radius: "btc",
        id: "4-11",
        introduce: "introduce.takerlongshortRatio",
        navigation: "sellRatio", //导航组件名称
        assets: "BTCUSDT、ETHUSDT",
        interval: "menu.interval3",
        type: "L2",
        authority: "registered", //注册用户
      },
    ],
  },
  //#region
  // {
  //   //持有者分布
  //   label: "menu.holders",
  //   icon: "i izhexiantu-xianxing",
  //   nested: "peers", //判断是否多层嵌套
  //   id: "5",
  //   children: [

  //     //   {
  //     //   //持有者地址数分布 这个就是多层的
  //     //   label: "menu.holderAddress",
  //     //   icon: "i izhexiantu-xianxing",
  //     //   id: "B08-1-6",
  //     //   children: [
  //     //     {
  //     //       //余额>=0 and <0.01的地址 币龄分布表
  //     //       // path: "/",
  //     //       label: "menu.Currency2",
  //     //       componentReq: "getDayBalanceData",
  //     //       radius: "btc",
  //     //       id: "01-35-1",
  //     //       value: 0,
  //     //       introduce: "introduce.getDayBalanceData",
  //     //       navigation: "balanceData",
  //     //       assets: "BTC",
  //     //       interval: "menu.interval3",
  //     //       type: "L3",
  //     //       authority: "advance", //付费用户
  //     //     },

  //     //   ],
  //     // },
  //     {
  //       //持有者地址数详细分布(按持有时间分段)  这个就是多层的
  //       label: "menu.Currency1",
  //       icon: "i izhexiantu-xianxing",
  //       id: "01-35",
  //       children: [

  //       ],
  //     },
  //     {
  //       //持有者币数量详细分布(按持有时间分段)

  //       label: "menu.Currency10",
  //       icon: "i izhexiantu-xianxing",
  //       id: "01-36",
  //       children: [

  //       ],
  //     },
  //   ],
  // },

  // {
  //   label: "待分配",
  //   icon: "i itubiao2",
  //   nested: "peers", //判断是否多层嵌套
  //   id: "100",
  //   children: [
  //     // {
  //     //   //新的MVRV
  //     //   path: "/",
  //     //   label: "新的MVRV",
  //     //   icon: "i igl-folderOpen",
  //     //   componentReq: "ethbigtxcount",
  //     //   radius: "btc",
  //     //   id: "23-100",
  //     //   introduce: "introduce.ethbigtxcount",
  //     //   navigation: "mvrv",
  //     //   assets: "BTC、ETH",
  //     //   interval: "menu.interval3",
  //     // },

  //     // {//区块实时交易量 不显示
  //     //   path: "/",
  //     //   label: "menu.onchain3",
  //     //   icon: "i igl-folderOpen",
  //     //   componentReq: "blockAmount",
  //     //   radius: "btc",
  //     //   id: "23-13",
  //     //   introduce: "introduce.blockAmount",
  //     //   navigation: "blockAmount",
  //     //   assets: "BTC",
  //     //   interval: "menu.interval3",
  //     // },
  //     // {
  //     //   //日交易详情
  //     //   path: "/",
  //     //   label: "menu.onchain4",
  //     //   icon: "i igl-folderOpen",
  //     //   componentReq: "dailyBuySell",
  //     //   radius: "btc",
  //     //   id: "23-14",
  //     //   introduce: "introduce.dailyBuySell",
  //     //   navigation: "dailyBuySell",
  //     //   assets: "BTC",
  //     //   interval: "menu.interval3",
  //     // },

  //     // {//暂时注释 巨鲸 币数量变动 /改为 巨鲸交易监控
  //     //   path: "/", //与Get Top List共用
  //     //   label: "menu.onchain16",
  //     //   icon: "i igl-folderOpen",
  //     //   componentReq: "getTopListWatch",
  //     //   radius: "btc",
  //     //   id: "23-26",
  //     //   introduce: "introduce.getTopListWatch",
  //     //   navigation: "topList", //导航组件名称
  //     //   assets: "BTC",
  //     //   interval: "menu.interval3",
  //     // },

  //     // {//地址对应标记持有者名称关系列表
  //     //   path: "/",
  //     //   label: "menu.onchain18",
  //     //   icon: "i igl-folderOpen",
  //     //   componentReq: "btcTags",
  //     //   radius: "btc",
  //     //   id: "23-32",
  //     //   introduce: "introduce.btcTags",
  //     //   navigation: "btctags", //导航组件名称
  //     //   assets: "BTC、ETH",
  //     //   interval: "menu.interval3",
  //     // },
  //   ],
  // },
  // {
  //   //技术指标
  //   label: "menu.technology",
  //   icon: "i izhexiantu-xianxing",
  //   nested: "peers", //判断是否多层嵌套 就是这些 多给他一个键 就是对应多语言的键 每个项都要有对把 对 先写两个试试
  //   id: "1",
  //   children: [
  //     // {
  //     //   //MVRV
  //     //   path: "/",
  //     //   label: "menu.technology1",
  //     //   icon: "i igl-folderOpen",
  //     //   req: "market",
  //     //   radius: `mvrv`,
  //     //   coin: "BTC",
  //     //   id: "23-1",
  //     //   introduce: "introduce.MVRV",
  //     //   assets: "BTC、ETH、LTC",
  //     //   interval: "menu.interval3",
  //     //   currencyNavigation: "USDT",
  //     // },

  //     // {//NVTRatio
  //     //   path: "/",
  //     //   label: "menu.technology3",
  //     //   icon: "i igl-folderOpen",
  //     //   req: "market",
  //     //   radius: "NVTRatio",
  //     //   coin: "BTC",
  //     //   id: "1-3",
  //     //   introduce: "introduce.NVTRatio",
  //     //   assets: "BTC、ETH、LTC",
  //     //   interval: "menu.interval3",
  //     // },
  //     // {//NVTSignal
  //     //   path: "/",
  //     //   label: "menu.technology4",
  //     //   icon: "i igl-folderOpen",
  //     //   req: "market",
  //     //   radius: "NVTSignal",
  //     //   coin: "BTC",
  //     //   id: "1-4",
  //     //   introduce: "introduce.NVTSignal",
  //     //   assets: "BTC、ETH、LTC",
  //     //   interval: "menu.interval3",
  //     // },

  //     // {
  //     //   //ETF持有比特币
  //     //   path: "/",
  //     //   label: "menu.technology9",
  //     //   icon: "i igl-folderOpen",
  //     //   req: "ETF",
  //     //   radius: "Holding",
  //     //   id: "1-9",
  //     //   introduce: "introduce.Holding",
  //     //   assets: "无",
  //     //   interval: "menu.interval3",
  //     // },
  //     // {
  //     //   //ETF比特币变动
  //     //   path: "/",
  //     //   label: "menu.technology10",
  //     //   icon: "i igl-folderOpen",
  //     //   req: "ETF",
  //     //   radius: "Flows",
  //     //   id: "1-10",
  //     //   introduce: "introduce.Flows",
  //     //   assets: "无",
  //     //   interval: "menu.interval3",
  //     // },

  //     // {
  //     //   //已实现流通市值
  //     //   path: "/",
  //     //   label: "menu.technology12",
  //     //   icon: "i igl-folderOpen",
  //     //   componentReq: "capReal",
  //     //   radius: "btc",
  //     //   id: "1-12",
  //     //   introduce: "introduce.capReal",
  //     //   navigation: "capReal", //导航组件名称
  //     //   assets: "BTC",
  //     //   interval: "menu.interval3",
  //     // },

  //   ],
  // },

  // {//地址/活动地址/新增地址及下面的页面
  //   label: "menu.address",
  //   icon: "i iqianbao",
  //   id: "4",
  //   children: [
  //     {
  //       path: "/",
  //       label: "menu.address1",
  //       icon: "i 24igl-folderOpen",
  //       type: "L1",
  //       id: "4-1",
  //       children: [
  //         {
  //           // path: "/1",
  //           label: `menu.address2`,
  //           req: "activeAddress",
  //           radius: "btc",
  //           id: "4-1-1",
  //           introduce: "introduce.activeAddress",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/2",
  //           label: "menu.address3",
  //           req: "sendingAddress",
  //           radius: "btc",
  //           id: "4-1-2",
  //           introduce: "introduce.sendingAddress",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/3",
  //           label: "menu.address4",
  //           req: "receivingAddress",
  //           radius: "btc",
  //           id: "4-1-3",
  //           introduce: "introduce.receivingAddress",
  //           interval: "menu.interval3",
  //         },
  //       ],
  //     },
  //     {
  //       path: "/",
  //       label: "menu.address5",
  //       icon: "i 24igl-folderOpen",
  //       type: "L1",
  //       id: "4-2",
  //       children: [
  //         {
  //           path: "/1",
  //           label: "menu.address6",
  //           req: "newAddress",
  //           radius: "btc",
  //           id: "4-2-1",
  //           introduce: "introduce.newAddress",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           path: "/2",
  //           label: "menu.address7",
  //           req: "totalAddress",
  //           radius: "btc",
  //           id: "4-2-2",
  //           introduce: "introduce.totalAddress",
  //           interval: "menu.interval3",
  //         },
  //       ],
  //     },
  //   ],
  // },

  // {
  //   ///交易汇总
  //   label: "menu.transactions",
  //   icon: "i ijiantou_zuoyouqiehuan",
  //   id: "20",
  //   children: [
  //     {
  //       //交易规模
  //       // path: "/",
  //       label: "menu.transactions1",
  //       icon: "i iyonghuguanli_huaban",
  //       type: "L1",
  //       id: "20-1",
  //       children: [
  //         {
  //           //每天交易规模
  //           // path: "/",
  //           label: "menu.transactions2",
  //           req: "transsizetotal",
  //           radius: "btc",
  //           id: "20-1-1",
  //           introduce: "introduce.transsizetotal",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           //每秒交易规模
  //           // path: "/",
  //           label: "menu.transactions3",
  //           req: "transsizemean",
  //           radius: "btc",
  //           id: "20-1-2",
  //           introduce: "introduce.transsizemean",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //       ],
  //     },
  //     {
  //       //交易量
  //       // path: "/",
  //       label: "menu.transactions4",
  //       icon: "i iyonghuguanli_huaban",
  //       type: "L1",
  //       id: "20-2",
  //       children: [
  //         {
  //           //成交次数
  //           // path: "/",
  //           label: "menu.transactions5",
  //           req: "transactions",
  //           radius: "btc",
  //           id: "20-2-1",
  //           introduce: "introduce.transactions",
  //           assets: "BTC、ETH、LTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           //日成交率
  //           // path: "/",
  //           label: "menu.transactions6",
  //           req: "transrate",
  //           radius: "btc",
  //           id: "20-2-2",
  //           introduce: "introduce.transrate",
  //           assets: "BTC、ETH、LTC",
  //           interval: "menu.interval3",
  //         },
  //       ],
  //     },
  //   ],
  // },

  // {//分配数据
  //   label: "menu.Distribution",
  //   icon: "i izhexiantu_o",
  //   nested: "peers", //判断是否多层嵌套
  //   id: "33",
  //   children: [
  //     {
  //       path: "/",
  //       label: "menu.Distribution1",
  //       icon: "i iwenjianjia",
  //       type: "L2",
  //       req: "distribution",
  //       radius: "tenths",
  //       coin: "BTC",
  //       id: "33-1",
  //       assets: "BTC、ETH",
  //       introduce: "introduce.distribution",
  //       interval: "menu.interval3",
  //     },
  //     {
  //       path: "/",
  //       label: "menu.Distribution2",
  //       icon: "i iwenjianjia",
  //       type: "L2",
  //       req: "distribution",
  //       radius: "hundredth",
  //       coin: "BTC",
  //       id: "33-2",
  //       assets: "BTC、ETH",
  //       introduce: "introduce.distribution1",
  //       interval: "menu.interval3",
  //     },
  //     {
  //       path: "/",
  //       label: "menu.Distribution3",
  //       icon: "i iwenjianjia",
  //       type: "L2",
  //       req: "distribution",
  //       radius: "units",
  //       coin: "BTC",
  //       id: "33-3",
  //       assets: "BTC、ETH",
  //       introduce: "introduce.distribution2",
  //       interval: "menu.interval3",
  //     },
  //     {
  //       path: "/",
  //       label: "menu.Distribution4",
  //       icon: "i iwenjianjia",
  //       type: "L2",
  //       req: "distribution",
  //       radius: "tens",
  //       coin: "BTC",
  //       id: "33-4",
  //       assets: "BTC、ETH",
  //       introduce: "introduce.distribution3",
  //       interval: "menu.interval3",
  //     },
  //     {
  //       path: "/",
  //       label: "menu.Distribution5",
  //       icon: "i iwenjianjia",
  //       type: "L2",
  //       req: "distribution",
  //       radius: "hundreds",
  //       coin: "BTC",
  //       id: "33-5",
  //       assets: "BTC、ETH",
  //       introduce: "introduce.distribution4",
  //       interval: "menu.interval3",
  //     },
  //     {
  //       path: "/",
  //       label: "menu.Distribution6",
  //       icon: "i iwenjianjia",
  //       type: "L2",
  //       req: "distribution",
  //       radius: "kilo",
  //       coin: "BTC",
  //       id: "33-6",
  //       assets: "BTC、ETH",
  //       introduce: "introduce.distribution5",
  //       interval: "menu.interval3",
  //     },
  //     {
  //       path: "/",
  //       label: "menu.Distribution7",
  //       icon: "i iwenjianjia",
  //       type: "L2",
  //       req: "distribution",
  //       radius: "myriad",
  //       coin: "BTC",
  //       id: "33-7",
  //       assets: "BTC、ETH",
  //       introduce: "introduce.distribution6",
  //       interval: "menu.interval3",
  //     },
  //   ],
  // },

  // {
  //   //主要交易所衍生数据
  //   label: "menu.derivatives",
  //   icon: "i i-zhuzhuangtu",
  //   id: "22--1",
  //   children: [
  //     {
  //       //具体数据
  //       path: "/",
  //       label: "menu.derivatives1",
  //       icon: "i iyonghuguanli_huaban",
  //       type: "L2",
  //       id: "22-1",
  //       children: [
  //         {
  //           //交易所日交易量
  //           path: "/",
  //           label: "menu.derivatives2",
  //           req: "derivatives",
  //           radius: "dailyVolume",
  //           coin: "BTC",
  //           id: "22-1-1",
  //           assets: "BTC、ETH",
  //           introduce: "introduce.dailyVolume",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           //交易所笔数变动
  //           path: "/",
  //           label: "menu.derivatives3",
  //           req: "derivatives",
  //           radius: "openInterest",
  //           coin: "BTC",
  //           id: "22-1-2",
  //           assets: "BTC、ETH",
  //           introduce: "introduce.openInterest",
  //           interval: "menu.interval3",
  //         },
  //       ],
  //     },
  //   ],
  // },

  // {//持有者币龄地址数/币数量分布图
  //   label: "menu.Currency",
  //   icon: "i ijiantou_zuoyouqiehuan",
  //   id: "28",
  //   children: [
  //     {
  //       // path: "/",
  //       label: "menu.Currency1",
  //       icon: "i iyonghuguanli_huaban",
  //       type: "L1",
  //       id: "25-1",
  //       children: [
  //         {
  //           // path: "/",
  //           label: "menu.Currency2",
  //           componentReq: "getDayBalanceData",
  //           radius: "btc",
  //           id: "25-1-1",
  //           value: 0,
  //           introduce: "introduce.getDayBalanceData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency3",
  //           componentReq: "getDayBalanceData",
  //           radius: "btc",
  //           id: "25-1-2",
  //           value: 0.01,
  //           introduce: "introduce.getDayBalanceData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency4",
  //           componentReq: "getDayBalanceData",
  //           radius: "btc",
  //           id: "25-1-3",
  //           value: 0.1,
  //           introduce: "introduce.getDayBalanceData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency5",
  //           componentReq: "getDayBalanceData",
  //           radius: "btc",
  //           id: "25-1-4",
  //           value: 1,
  //           introduce: "introduce.getDayBalanceData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency6",
  //           componentReq: "getDayBalanceData",
  //           radius: "btc",
  //           id: "25-1-5",
  //           value: 10,
  //           introduce: "introduce.getDayBalanceData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency7",
  //           componentReq: "getDayBalanceData",
  //           radius: "btc",
  //           id: "25-1-6",
  //           value: 100,
  //           introduce: "introduce.getDayBalanceData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency8",
  //           componentReq: "getDayBalanceData",
  //           radius: "btc",
  //           id: "25-1-7",
  //           value: 1000,
  //           introduce: "introduce.getDayBalanceData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency9",
  //           componentReq: "getDayBalanceData",
  //           radius: "btc",
  //           id: "25-1-8",
  //           value: 10000,
  //           introduce: "introduce.getDayBalanceData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //       ],
  //     },
  //     {
  //       // path: "/",
  //       label: "menu.Currency10",
  //       icon: "i iyonghuguanli_huaban",
  //       type: "L1",
  //       id: "25-2",
  //       children: [
  //         {
  //           // path: "/",
  //           label: "menu.Currency11",
  //           componentReq: "getDayBalanceAmountData",
  //           radius: "btc",
  //           id: "25-2-1",
  //           value: 0,
  //           introduce: "introduce.getDayBalanceAmountData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency12",
  //           componentReq: "getDayBalanceAmountData",
  //           radius: "btc",
  //           id: "25-2-2",
  //           value: 0.01,
  //           introduce: "introduce.getDayBalanceAmountData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency13",
  //           componentReq: "getDayBalanceAmountData",
  //           radius: "btc",
  //           id: "25-2-3",
  //           value: 0.1,
  //           introduce: "introduce.getDayBalanceAmountData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency14",
  //           componentReq: "getDayBalanceAmountData",
  //           radius: "btc",
  //           id: "25-2-4",
  //           value: 1,
  //           introduce: "introduce.getDayBalanceAmountData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency15",
  //           componentReq: "getDayBalanceAmountData",
  //           radius: "btc",
  //           id: "25-2-5",
  //           value: 10,
  //           introduce: "introduce.getDayBalanceAmountData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency16",
  //           componentReq: "getDayBalanceAmountData",
  //           radius: "btc",
  //           id: "25-2-6",
  //           value: 100,
  //           introduce: "introduce.getDayBalanceAmountData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency17",
  //           componentReq: "getDayBalanceAmountData",
  //           radius: "btc",
  //           id: "25-2-7",
  //           value: 1000,
  //           introduce: "introduce.getDayBalanceAmountData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //         {
  //           // path: "/",
  //           label: "menu.Currency18",
  //           componentReq: "getDayBalanceAmountData",
  //           radius: "btc",
  //           id: "25-2-8",
  //           value: 10000,
  //           introduce: "introduce.getDayBalanceAmountData",
  //           navigation: "balanceData",
  //           assets: "BTC",
  //           interval: "menu.interval3",
  //         },
  //       ],
  //     },
  //   ],
  // },
  //#endregion
]
export const ethMenu =[//组件跳转的权限

 
]

export const stableMenu =[//组件跳转的权限

 
]